// src/layout/AIAgent/intents.js
// Shared quick-questions + intent matchers used by both AI chat surfaces
// (floating AgentChat and the AIDrawer) so routing stays consistent.

export const NUDGE_QUICK_QUESTION =
  "Please create a nudge based on insight of heatmap and user journey";
export const ABTEST_QUICK_QUESTION =
  "Give me a UI to create an A/B test to improve conversion rate";
export const LANDING_QUICK_QUESTION =
  "Redesign my landing page using heatmap & user journey insights";
export const IMPROVE_QUICK_QUESTION = "How can I improve my conversion rate?";

const has = (t, re) => re.test(t);
const ACTION_VERB = /(ui|create|build|give|make|design|generate|do|run|want|start|set ?up|new|need|redesign|update|rebuild)/;

// "run an A/B test", "i want to do abtest", "create a/b test"
export const isAbTestStudioRequest = (text) => {
  const t = (text || "").toLowerCase();
  return (has(t, /\ba\/?b\s*test\b/) || has(t, /\babtest\b/)) && has(t, ACTION_VERB);
};

// "redesign my landing page", "improve my landing page"
export const isLandingBuilderRequest = (text) => {
  const t = (text || "").toLowerCase();
  return has(t, /landing\s*page/) && has(t, ACTION_VERB);
};

// "create a nudge", "add a nudge" (but NOT "how are my nudges performing")
export const isNudgeRequest = (text) => {
  const t = (text || "").toLowerCase();
  if (t === NUDGE_QUICK_QUESTION.toLowerCase()) return true;
  return has(t, /\bnudge/) && has(t, /(create|add|make|build|new|do|want|need|set ?up)/);
};

// "how to improve conversion", "increase sales", "boost revenue"
export const isImproveConversionRequest = (text) => {
  const t = (text || "").toLowerCase();
  return (
    has(t, /(improve|increase|boost|grow|raise|lift|optimi[sz]e|how.*(do|can).*(convert|conversion))/) &&
    has(t, /(conversion|convert|sales|revenue|funnel)/)
  );
};
